import { render, staticRenderFns } from "./Erlianhot.vue?vue&type=template&id=ba4fbe3c&scoped=true"
import script from "./Erlianhot.vue?vue&type=script&lang=js"
export * from "./Erlianhot.vue?vue&type=script&lang=js"
import style0 from "./Erlianhot.vue?vue&type=style&index=0&id=ba4fbe3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4fbe3c",
  null
  
)

export default component.exports